export const API_URL = "https://dev-api-v3.dreamlab.com.vn";
export const PAGE_LIMIT = 25;
